import { render, staticRenderFns } from "./EleFormDataEditor.vue?vue&type=template&id=6220b89d&"
import script from "./EleFormDataEditor.vue?vue&type=script&lang=js&"
export * from "./EleFormDataEditor.vue?vue&type=script&lang=js&"
import style0 from "./EleFormDataEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports